module.exports = __webpack_public_path__ + "static/img/23-红英小学(唐家岭校区)1.555aeb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/23-红英小学(唐家岭校区)1.png
// module id = 210/
// module chunks = 0